import React from "react";

function GovCloudMigration() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>GovCloud Migration</h1>
      <p style={{ color: "gray" }}>Content for GovCloud Migration will be added soon.</p>
    </div>
  );
}

export default GovCloudMigration;
